/**
 * @generated SignedSource<<eedb90cbb1292b4fb94e29804aa792cf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BreadCrumbsHeader_query$data = {
  readonly whoami: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"useDocsUrl_query">;
  readonly " $fragmentType": "BreadCrumbsHeader_query";
};
export type BreadCrumbsHeader_query$key = {
  readonly " $data"?: BreadCrumbsHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BreadCrumbsHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BreadCrumbsHeader_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDocsUrl_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "81f7ac763972673c926802e1a0cef1ab";

export default node;
